<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-start pt-4 px-2 px-lg-0 pl-lg-4 pl-xl-4>
      <v-flex xs12>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs12 text-left align-self-center>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 22px;
                color: #1c1c1c;
              "
            >
              Sales Report
            </span>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Filters Section -->
      <v-flex xs12 pt-6>
        <v-card flat outlined class="pa-4 mr-lg-4">
          <v-layout wrap justify-start>
            <!-- From Date -->
            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">From Date</span>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.fromDate"
                    placeholder="Select From Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.fromDate"
                  @input="menu1 = false"
                  color="#3ea56e"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- To Date -->
            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">To Date</span>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.toDate"
                    placeholder="Select To Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.toDate"
                  @input="menu2 = false"
                  color="#3ea56e"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Order Status -->
            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">Order Status</span>
              <v-select
                outlined
                dense
                v-model="filters.orderStatus"
                :items="statusOptions"
                placeholder="Select Status"
                hide-details
              ></v-select>
            </v-flex>

            <v-flex xs12 px-2 pt-2>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm6 md4>
                  <v-btn
                    color="#3ea56e"
                    dark
                    depressed
                    class="text-capitalize"
                    @click="getReportData"
                  >
                    Generate Report
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 text-right v-if="reportData.length > 0">
                  <v-btn
                    outlined
                    color="red"
                    class="text-capitalize mr-2"
                    @click="downloadReport('pdf')"
                  >
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    Download PDF
                  </v-btn>
                  <v-btn
                    outlined
                    color="green"
                    class="text-capitalize"
                    @click="downloadReport('excel')"
                  >
                    <v-icon left small>mdi-file-excel</v-icon>
                    Download Excel
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- Summary Section -->
      <v-flex xs12 pt-6 v-if="summaryData && reportData.length > 0">
        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md4 lg3 xl2 pa-2 v-for="(val, key) in summaryFields" :key="key">
            <v-card flat outlined class="pa-3 text-center" color="#f9f9f9">
              <div class="summary-label text-uppercase">{{ formatLabel(key) }}</div>
              <div class="summary-value">{{ formatValue(key, summaryData[key]) }}</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Report Table -->
      <v-flex xs12 pt-6 pr-lg-4>
        <v-card flat outlined>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left py-4">Order ID</th>
                  <th class="text-left">Date</th>
                  <th class="text-left">Product Name</th>
                  <th class="text-center">Customer</th>
                  <th class="text-center">Qty</th>
                  <th class="text-center">Price</th>
                  <th class="text-center">Total</th>
                  <th class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in reportData" :key="item._id">
                  <td class="text-left" style="font-family: poppinsmedium;">{{ item.orderID }}</td>
                  <td class="text-left">{{ formatDate(item.create_date) }}</td>
                  <td class="text-left">{{ item.productname }}</td>
                  <td class="text-center">
                    <div v-if="item.uid">
                      <span style="font-family: poppinsmedium;">{{ item.uid.firstname }} {{ item.uid.lastname }}</span>
                      <br />
                      <small style="color: #666;">{{ item.uid.phone }}</small>
                    </div>
                  </td>
                  <td class="text-center">{{ item.quantity }} {{ item.unit }}</td>
                  <td class="text-center">₹{{ item.offerPrice }}</td>
                  <td class="text-center" style="font-family: poppinssemibold;">₹{{ item.TotalAmount }}</td>
                  <td class="text-center">
                    <v-chip
                      small
                      :color="getStatusColor(item.status)"
                      dark
                    >
                      {{ item.status }}
                    </v-chip>
                  </td>
                </tr>
                <tr v-if="reportData.length === 0">
                  <td colspan="8" class="text-center py-8">
                    <span style="font-family: poppinsregular; color: #808080; font-size: 20px;">
                      Oops! No data found
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: "",
      filters: {
        fromDate: null,
        toDate: null,
        orderStatus: "All",
      },
      statusOptions: ["All", "Order Confirmed", "Shipped", "Out For Delivery", "Delivered"],
      menu1: false,
      menu2: false,
      reportData: [],
      summaryData: null,
      summaryFields: {
        totalSales: "Total Sales",
        totalItems: "Total Items",
        totalTax: "Total Tax",
        totalPacking: "Total Packing",
        totalDiscount: "Total Discount",
        uniqueOrders: "Unique Orders",
      },
    };
  },
  beforeMount() {
    this.getReportData();
  },
  methods: {
    getReportData() {
      this.appLoading = true;
      const payload = { ...this.filters };
      // if (payload.status === "All") delete payload.status;

      axios({
        method: "POST",
        url: "/seller/report/sales",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: payload,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.reportData = response.data.reportData;
            this.summaryData = response.data.summary;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.reportData = [];
            this.summaryData = null;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    downloadReport(type) {
      const url = type === "pdf" ? "/seller/report/sales/pdf" : "/seller/report/sales/excel";
      const payload = { ...this.filters };
      // if (payload.status === "All") delete payload.status;

      this.appLoading = true;
      axios({
        method: "POST",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: payload,
        responseType: "blob",
      })
        .then((response) => {
          this.appLoading = false;
          const blob = new Blob([response.data], {
            type: type === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `SalesReport_${new Date().getTime()}.${type === "pdf" ? "pdf" : "xlsx"}`;
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Error downloading report";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    formatLabel(key) {
      return this.summaryFields[key] || key;
    },
    formatValue(key, value) {
      if (key === 'totalItems') {
        return value || 0;
      }
      if (key.toLowerCase().includes("total") || key.toLowerCase().includes("sales")) {
        return "₹" + (value || 0).toFixed(2);
      }
      return value || 0;
    },
    getStatusColor(status) {
      switch (status) {
        case "Active":
          return "green";
        case "Pending":
          return "orange";
        case "Rejected":
          return "red";
        case "Deleted":
          return "grey";
        default:
          return "blue";
      }
    },
  },
};
</script>

<style scoped>
.report-label {
  font-family: poppinsmedium;
  font-size: 14px;
  color: #555;
  display: block;
  margin-bottom: 4px;
}
.summary-label {
  font-family: poppinsregular;
  font-size: 11px;
  color: #777;
}
.summary-value {
  font-family: poppinsbold;
  font-size: 18px;
  color: #3ea56e;
}
</style>
